module.exports = __webpack_public_path__ + "static/img/head6.5caddd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head6.png
// module id = khRI
// module chunks = 1